// Banks differ in which transaction identifier they supply. Never use amount/date
// alone: two genuine payments can otherwise collapse into one row.
export function transactionBankId(transaction: Record<string, unknown>): string {
    return String(transaction['Transaction ID'] || transaction.transactionId || transaction.id || transaction.internalTransactionId || transaction.entryReference || '').trim();
}
function identities(transaction: Record<string, unknown>): string[] {
    const id = transactionBankId(transaction);
    if (!id) return [];
    const result: string[] = [];
    const iban = String(transaction['Account IBAN'] || transaction.iban || transaction.iban2 || '').replace(/\s+/g, '').toUpperCase();
    if (iban) result.push(JSON.stringify([id, 'iban', iban]));
    // The existing key ends in the stable account identity. Retain compatibility
    // with pre-renewal keys and imports whose core Transaction ID was empty.
    const key = String(transaction['Unique Key'] || '');
    const account = key.slice(key.lastIndexOf('_') + 1);
    if (key.includes('_') && account) result.push(JSON.stringify([id, 'account', account]));
    return result;
}
export function filterNewTransactions(transactions: Record<string, unknown>[], headers: string[], rows: unknown[][]): Record<string, unknown>[] {
    const records = rows.map(row => Object.fromEntries(headers.map((header,i) => [header,row[i]])));
    const existing = new Set(records.flatMap(identities));
    const ambiguous = new Set(records.filter(record => !identities(record).length).map(transactionBankId).filter(Boolean));
    return transactions.filter(transaction => {
        if (ambiguous.has(transactionBankId(transaction))) throw new Error('An existing transaction has no account identity. This account was not imported to avoid duplicates; please contact support to match the legacy row.');
        const aliases = identities(transaction);
        if (!aliases.length) throw new Error('The bank returned a transaction without a stable transaction/account identifier. This account was not imported; please contact support.');
        if (aliases.some(id => existing.has(id))) return false;
        aliases.forEach(id => existing.add(id));
        return true;
    });
}
